namespace Gamification.Gamification {
    export interface ProdottiClassiAssetEsperienzeRow {
        IdProdottoClasseAssetEsperienza?: number;
        UserId?: number;
        TenantId?: number;
        IdProdottoClasse?: number;
        IdAssetEsperienza?: number;
        IdProdottoClasseIdProdotto?: number;
        IdProdottoClasseNome?: string;
        IdAssetEsperienzaNome?: string;
        IdProdottoClasseProdottoNome?: string;
    }

    export namespace ProdottiClassiAssetEsperienzeRow {
        export const idProperty = 'IdProdottoClasseAssetEsperienza';
        export const localTextPrefix = 'Gamification.ProdottiClassiAssetEsperienze';
        export const lookupKey = 'Gamification.ProdottiClassiAssetEsperienze';

        export function getLookup(): Q.Lookup<ProdottiClassiAssetEsperienzeRow> {
            return Q.getLookup<ProdottiClassiAssetEsperienzeRow>('Gamification.ProdottiClassiAssetEsperienze');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdProdottoClasseAssetEsperienza = "IdProdottoClasseAssetEsperienza",
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoClasse = "IdProdottoClasse",
            IdAssetEsperienza = "IdAssetEsperienza",
            IdProdottoClasseIdProdotto = "IdProdottoClasseIdProdotto",
            IdProdottoClasseNome = "IdProdottoClasseNome",
            IdAssetEsperienzaNome = "IdAssetEsperienzaNome",
            IdProdottoClasseProdottoNome = "IdProdottoClasseProdottoNome"
        }
    }
}
